module.exports = __webpack_public_path__ + "30e1217cf28f1f62233ff740300b9019.svg";